import { Link } from "react-router-dom";

const SuggestionItem = ({ user, onAddFriend, isPending }) => {
    return (
        <div className="suggestionCard">
            <div className="userInfo">
                <Link to={`/profile/${user.id}`}>
                    <img
                        src={user.profilePic || "/public/noAvatar.png"} 
                        alt={user.name}
                        className="profilePic"
                    />
                </Link>

                <div className="details">
                    <Link 
                        to={`/profile/${user.id}`} 
                        style={{ textDecoration: "none", color: "inherit" }}
                    >
                        <span className="name">
                            {user.name}
                        </span>
                    </Link>

                    <span className="username">
                        @{user.username}
                    </span>
                </div>
            </div>

            <div className="actionButtons">
                <button
                    className="addFriendBtn"
                    onClick={() => onAddFriend(user.id)}
                    disabled={isPending}
                >
                    Add Friend
                </button>
            </div>
        </div>
    );
};

export default SuggestionItem;